import { render } from "./RiversBanner.vue?vue&type=template&id=7f126cb0"
import script from "./RiversBanner.vue?vue&type=script&lang=js"
export * from "./RiversBanner.vue?vue&type=script&lang=js"

import "./RiversBanner.vue?vue&type=style&index=0&id=7f126cb0&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\compro.rimba.vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__